import { imageExtensions } from '../../constants/file';

const defaultResult = { files: [], images: [] };

export const groupAttachmentsByType = (attachments) => {
  if (!Array.isArray(attachments) || attachments.length === 0) {
    return defaultResult;
  }

  return attachments.reduce(
    (result, attachment) => {
      imageExtensions.has(attachment.extension.toLowerCase())
        ? result.images.push(attachment)
        : result.files.push(attachment);

      return result;
    },
    { files: [], images: [] }
  );
};
